import gaTracker from './gaTracker';

export default () => gaTracker('trackingId');
